module.exports = __webpack_public_path__ + "static/img/4.25fd98b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Cumplimiento-Disposiciones-Legales/4.png
// module id = tOCa
// module chunks = 0